import React from "react";
import side from '../../Images/side-2.png'
import { Sidebar } from "lucide-react";
/**
 * Section: Was Sie konkret gewinnen
 * - Layout matches your reference: left content (title + feature grid), right image card
 * - Tailwind only (no extra libs)
 * - Uses clean custom inline SVG icons (so you don't need lucide)
 */

// Brand colors (adjust if needed)
const NAVY = "#1A4564";
const ACCENT = "#BEE362";

// ---------- Custom Icons (inline SVG) ----------
const IconClock = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M12 6v6l4 2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconSavings = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M7 10V7.8A4.8 4.8 0 0 1 11.8 3h.4A4.8 4.8 0 0 1 17 7.8V10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M6 10h12a2 2 0 0 1 2 2v4.5A4.5 4.5 0 0 1 15.5 21h-7A4.5 4.5 0 0 1 4 16.5V12a2 2 0 0 1 2-2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M12 13v5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10.5 15h3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconGrowth = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M4 19V5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4 19h16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7 15l4-4 3 3 6-7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 7h2v2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconBrain = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9.5 4.2A4.5 4.5 0 0 0 5 8.7v.6A3.7 3.7 0 0 0 4 12v1a3.7 3.7 0 0 0 1 2.7V16a4 4 0 0 0 4 4h.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M14.5 4.2A4.5 4.5 0 0 1 19 8.7v.6A3.7 3.7 0 0 1 20 12v1a3.7 3.7 0 0 1-1 2.7V16a4 4 0 0 1-4 4h-.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9.5 20v-6.2A2.8 2.8 0 0 0 7 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M14.5 20v-6.2A2.8 2.8 0 0 1 17 11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconScale = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M12 3v6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M12 15v6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9 12h6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.4 5.6a3 3 0 0 1 0 4.2l-1.6 1.6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5.6 18.4a3 3 0 0 0 4.2 0l1.6-1.6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.4 18.4a3 3 0 0 0 0-4.2l-1.6-1.6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M5.6 5.6a3 3 0 0 1 4.2 0l1.6 1.6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

// ---------- Component ----------
export default function WasSieKonkretGewinnen({
  title = "Was unsere Kunden konkret gewinnen",
  eyebrow = "NUTZEN & ROI (Zahlen verkaufen)",
  imageSrc = side,
}) {
  const items = [
    {
      icon: IconClock,
      heading: "Zeit",
      text: "Zeitersparnis im Tagesgeschäft",
    },
    {
      icon: IconSavings,
      heading: "Kostenersparnis",
      text: "Reduzierte Personalkosten",
    },
    {
      icon: IconGrowth,
      heading: "Mehr Umsatz",
      text: "Mehr Leads & Umsatz",
    },
    {
      icon: IconBrain,
      heading: "Wissen bleibt",
      text: "Wissen bleibt im Unternehmen",
    },
    {
      icon: IconScale,
      heading: "Skalierbarkeit",
      text: "Skalierbarkeit ohne Neueinstellungen",
      span: true, // make last card span 2 columns on desktop (looks clean with 5 items)
    },
  ];

  return (
    <section className="w-[90%] 2xl:w-[70%] mx-auto bg-white py-10 sm:py-14">
      <div className="">
        <div className="relative overflow-hidden rounded-3xl bg-[#0B1F33] shadow-[0_18px_60px_rgba(0,0,0,0.18)] ring-1 ring-white/10">
          {/* Soft glow */}
          <div
            className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full blur-3xl opacity-25"
            style={{ background: ACCENT }}
          />
          <div
            className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full blur-3xl opacity-15"
            style={{ background: "#5aa6ff" }}
          />

          <div className="grid items-stretch gap-8 p-6 sm:p-10 lg:grid-cols-12 lg:gap-10">
            {/* Left */}
            <div className="lg:col-span-7">
              <p className="text-sm font-semibold tracking-wide text-white/60">
                {eyebrow}
              </p>

              <h2 className="mt-2 h2-mb h2-md h2-lg h2-2xl !text-white">
                {title}
              </h2>

              <div className="mt-7 grid gap-4 sm:grid-cols-2">
                {items.map((it, idx) => {
                  const Icon = it.icon;
                  return (
                    <div
                      key={idx}
                      className={[
                        "group relative flex gap-4 rounded-2xl bg-white/5 p-4 ring-1 ring-white/10 backdrop-blur-sm",
                        "transition hover:bg-white/8 hover:ring-white/15",
                        it.span ? "sm:col-span-2" : "",
                      ].join(" ")}
                    >
                      {/* Icon Box */}
                      <div
                        className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ring-1 ring-white/10"
                        style={{
                          background:
                            "linear-gradient(180deg, rgba(190,227,98,0.18), rgba(190,227,98,0.08))",
                        }}
                      >
                        <Icon
                          className="h-6 w-6"
                          style={{ color: ACCENT }}
                        />
                      </div>

                      {/* Text */}
                      <div className="min-w-0">
                        <p className="text-base font-bold text-white">
                          {it.heading}
                        </p>
                        <p className="mt-1 text-sm leading-relaxed text-white/70">
                          {it.text}
                        </p>
                      </div>

                      {/* Tiny accent line */}
                      <div
                        className="pointer-events-none absolute inset-x-4 bottom-0 h-px opacity-0 transition group-hover:opacity-100"
                        style={{
                          background:
                            "linear-gradient(90deg, transparent, rgba(190,227,98,0.55), transparent)",
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Right Image */}
            <div className="lg:col-span-5">
              <div className="relative h-full overflow-hidden rounded-3xl bg-white/5 ring-1 ring-white/10">
                <img
                  src={imageSrc}
                  alt="Team working"
                  className=" w-full object-cover h-full "
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-tr from-[#0B1F33]/70 via-transparent to-transparent" />
                {/* Badge */}
                <div className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white ring-1 ring-white/15 backdrop-blur">
                  <span
                    className="inline-block h-2 w-2 rounded-full"
                    style={{ background: ACCENT }}
                  />
                  Automatisierung, die wirkt
                </div>
              </div>
            </div>
          </div>

          {/* Bottom border glow */}
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-px opacity-60"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(190,227,98,0.55), transparent)",
            }}
          />
        </div>
      </div>
    </section>
  );
}
